import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguageContext = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguageContext must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Initialize with 'en' as default, then check localStorage
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      const savedLanguage = localStorage.getItem('joao-xavier-language');
      return savedLanguage || 'pt';
    }
    return 'pt';
  });

  // Update localStorage whenever language changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('joao-xavier-language', language);
    }
  }, [language]);

  const switchLanguage = (newLanguage) => {
    if (newLanguage === 'en' || newLanguage === 'pt') {
      setLanguage(newLanguage);
    }
  };

  const value = {
    language,
    switchLanguage,
    isEnglish: language === 'en',
    isPortuguese: language === 'pt'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;